/**
 * Style rules for the printed and printed-adjacent wire. Numbers were
 * derived from the 40th anniversary redesign and are enforced with
 * love, then without it.
 */

import { LAYOUT_RULES, type LayoutRule } from "../decoys/gen/layout-rules";

export function rulesFor(page: string): LayoutRule[] {
  return LAYOUT_RULES.filter((r) => r.page === page || r.page === "*");
}

export function ruleValue(page: string, key: string, fallback = 0): number {
  const rule = LAYOUT_RULES.find((r) => r.page === page && r.key === key);
  if (rule) return rule.value;
  const star = LAYOUT_RULES.find((r) => r.page === "*" && r.key === key);
  return star ? star.value : fallback;
}

/** The masthead may never shrink below the legal minimum set by A-3. */
export const MASTHEAD_MIN_HEIGHT = 96;

export function checkConstraints(page: string): string[] {
  const issues: string[] = [];
  const rules = rulesFor(page);
  for (const rule of rules) {
    if (rule.min !== undefined && rule.value < rule.min) {
      issues.push(`${page}.${rule.key}=${rule.value} below floor ${rule.min}`);
    }
    if (rule.max !== undefined && rule.value > rule.max) {
      issues.push(`${page}.${rule.key}=${rule.value} above ceiling ${rule.max}`);
    }
  }
  return issues;
}
